import {jsx} from 'panel';

import {ButtonEl} from 'common/components/button';
import {SelectEl, THEME} from 'common/components/select';
import {ButtonTheme} from 'common/components/button/constants';

import type {QueryEntrySection} from '../index';

export function AddEntryRow({el}: {el: QueryEntrySection}) {
  const isDisabled = el.helpers.isAddingDisabled();
  const typeItems = el.helpers.getAddListTypeItems();
  const tooltipAttrs = el.helpers.getAddEntryButtonTooltipAttrs();
  const singleEntryType = typeItems.length === 1 && typeItems[0].value;

  return (
    <div
      sel='.mp-query-entry.is-add-row'
      key='new-entry'
      class={{
        'is-disabled': isDisabled,
        [`for-${singleEntryType}`]: Boolean(singleEntryType),
      }}
    >
      {/** row body */}
      <div sel='.mp-query-entry-body'>
        <div sel='.mp-query-entry-add-toggle'>
          {/** include prefix spacing */}
          {el.state.prefixRenderer && <div sel='.entry-selector-prefix' />}

          {singleEntryType ? (
            <>
              <ButtonEl
                attrs={{
                  disabled: isDisabled,
                  theme: ButtonTheme.Tertiary,
                  icon: `plus`,
                  elref: `newEntryButton`,
                  tooltip: !isDisabled && tooltipAttrs,
                }}
                on={{
                  click: () => el.helpers.onAddTypeSelected(singleEntryType),
                }}
                hook={{
                  insert: ({elm}) => el.helpers.onAutofocusableElAdded(elm),
                }}
              >
                {el.attr(`add-entry-button-label`) || `Add`}
              </ButtonEl>
            </>
          ) : (
            <SelectEl
              attrs={{
                elref: `typeSelect`,
                disabled: isDisabled,
                icon: {leftIcon: `plus`, rightIcon: ``},
                'selected-option': el.attr(`add-entry-button-label`) || `Add`,
                'menu-width': el.attr(`add-entry-menu-width`),
                sections: [{items: typeItems}],
                theme: THEME.TERTIARY,
                tooltip: !isDisabled ? tooltipAttrs : null,
              }}
              on={{
                change: (ev: CustomEvent) => el.helpers.onAddTypeSelected(ev.detail.item.value),
              }}
              hook={{
                insert: ({elm}) => el.helpers.onAutofocusableElAdded(elm),
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
}
